var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contain"},[_c('el-container',{staticClass:"is-vertical"},[_c('AppBar'),_c('el-container',{staticClass:"custom-container"},[_c('SideNav'),(_vm.$route.path !== '/')?[_c('MenuFrame',[_vm._t("default")],2)]:[_vm._t("default")]],2)],1),_c('DingDong'),_c('NoticeDialog'),_c('AgreementDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }